//import Vue from 'vue'

const state = {
}

const getters = {
    status2variant(state) {
        return (status) => {
            const table = {
                'pending': 'light',
                'sent': 'info',
                'paid': 'primary',
                'completed': 'success',
                'canceling': 'secondary',
                'canceled': 'dark',
            }
            return table[status]
        }
    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        const response = await axios.post('/api/v1/f/' + encodeURIComponent(data.form_uuid) + (data.answer_uuid ? '/' + encodeURIComponent(data.answer_uuid) + '/' + encodeURIComponent(data.email_hashed): ''), data)
            .catch(error => error.response || null)

        return response
    },
    async destroy (context, data) {
        const response = await axios.delete(`/api/v1/forms/${data.form_id}/answers/${data.id}`, data)
            .catch(error => error.response || null)
        return response
    },
    async index (context, data) {
        const response = await axios.get('/api/v1/forms/' + encodeURIComponent(data.form_uuid) + '/answers/' + (data.user_id || ''), {
            params: (typeof data === 'object' ? data : null),
            responseType: 'json',
//            responseType: data.dl ? 'blob' : 'json',
        })
        .catch(error => error.response || null)
        return response
    },
    async list (context, id) {
        const response = await axios.get('/api/v1/f/', {
                params: {
                    owner_uuid: id,
                }
            })
            .catch(error => error.response || null)
        return response
    },
    async show (context, data) {
        const response = await axios.get('/api/v1/f/' + encodeURIComponent(data.form_uuid) + '/' + encodeURIComponent(data.answer_uuid) + '/' + encodeURIComponent(data.email_hashed))
            .catch(error => error.response || null)
        return response
    },
    async complete (context, data) {
        const response = await axios.put(`/api/v1/forms/${data.form_id}/answers/${data.id}/complete`, data)
            .catch(error => error.response || null)
        return response
    },
    async cancel (context, data) {
        const response = await axios.put('/api/v1/f/' + encodeURIComponent(data.form_uuid) + '/' + encodeURIComponent(data.answer_uuid) + '/' + encodeURIComponent(data.email_hashed) + '/cancel', data)
            .catch(error => error.response || null)
        return response
    },
    async pend(context, data) {
        const response = await axios.put(`/api/v1/forms/${data.form_id}/answers/${data.id}/pend`, data)
            .catch(error => error.response || null)
        return response
    },
    async change_email_name (context, data) {
        const response = await axios.post('/api/v1/f/' + encodeURIComponent(data.form_uuid) + '/' + data.id + '/change_email_name', data)
            .catch(error => error.response || null)

        return response
    },
//    async status (context, data) {
//        const response = await axios.put('/api/v1/forms/' + data.id + '/status', data)
//            .catch(error => error.response || null)
//        return response
//    },
//    async download (context, data) {
//        data = Object.assign(data, { download: true, })
//        const response = await axios.get('/api/v1/forms', {
//            params: (typeof data === 'object' ? data : null),
//            responseType: 'blob',
//            dataType: 'binary',
//            headers: { 'Cache-Control': 'no-cache' },
//        })
//        .catch(error => error.response || null)
//        Vue.prototype.download(response)
//        return response
//    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

